/* REBELLE Store Locator stopgaps. Upload as a theme asset, then in theme.liquid:
     <script src="{{ 'sl-cluster-by-country.js' | asset_url }}"></script>
   1) Cluster within a country (radius 350), but merge every country into one
      badge once the map is zoomed out past the default view.
   2) Cap the first-load store list so 5000+ list items stop blocking the main
      thread. Markers on the map are untouched.
   3) Order cluster badges by member count, so a big cluster is never hidden
      behind a small one. */

/* Tune this if the merchant wants a longer/shorter starting list. */
var SL_LIST_LIMIT = 100;

/* Zoom levels below this merge all countries into a single badge. null follows
   the app's own default_view_zoom (4 here), so the default view still splits. */
var SL_MERGE_BELOW_ZOOM = null;

/* ---- 0. one shared parse of locationsRaw (1.5 MB, both blocks need it) --- */
window.__slRawLocations = (function () {
  var cache;
  return function () {
    if (cache !== undefined) return cache;
    try {
      var raw = window.SCASLSetting && SCASLSetting.locationsRaw;
      var list = typeof raw === 'string' ? JSON.parse(raw) : raw;
      cache = Array.isArray(list) ? list : null;
    } catch (e) {
      cache = null;
    }
    return cache;
  };
})();

/* ---- 1. country-aware clustering ---------------------------------------- */
(function () {
  var RADIUS = 350;
  var MAX_ZOOM = 16;
  var coordCountry = null;

  function coordKey(lat, lng) {
    return lat.toFixed(5) + ',' + lng.toFixed(5);
  }

  function countryIndex() {
    if (coordCountry) return coordCountry;
    coordCountry = {};
    var list = window.__slRawLocations();
    for (var i = 0; list && i < list.length; i++) {
      var loc = list[i];
      if (!loc.lat || !loc.lng) continue;
      coordCountry[coordKey(parseFloat(loc.lat), parseFloat(loc.lng))] =
        loc.country_code || loc.country || '?';
    }
    return coordCountry;
  }

  function markerCountry(marker) {
    var pos = marker && marker.getPosition && marker.getPosition();
    if (!pos) return '?';
    var lat = pos.lat();
    var lng = pos.lng();
    if (isNaN(lat) || isNaN(lng)) return '?';
    return countryIndex()[coordKey(lat, lng)] || '?';
  }

  function mergeBelowZoom() {
    if (SL_MERGE_BELOW_ZOOM !== null) { return SL_MERGE_BELOW_ZOOM; }
    var z = parseInt((window.SCASLSetting || {}).default_view_zoom, 10);
    return isNaN(z) ? 4 : z;
  }

  function makeCountryAlgorithm(Algo) {
    var opts = { radius: RADIUS, maxZoom: MAX_ZOOM };
    var algo = new Algo(opts);
    var subs = {};
    var lastMerged = null;
    var lastZoom = null;
    algo.calculate = function (input) {
      var markers = (input && input.markers) || [];
      var zoom = input && input.map && input.map.getZoom ? Math.round(input.map.getZoom()) : null;
      var merged = zoom !== null && zoom < mergeBelowZoom();
      var groups = {};
      // Zoomed out far enough that per-country badges would sit on top of each
      // other (60 px apart at zoom 4, 15 px at zoom 2) -> one badge for all.
      if (merged) {
        groups['*'] = markers;
      } else {
        for (var i = 0; i < markers.length; i++) {
          var cc = markerCountry(markers[i]);
          if (!groups[cc]) { groups[cc] = []; }
          groups[cc].push(markers[i]);
        }
      }
      var clusters = [];
      var changed = false;
      for (var cc2 in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, cc2)) continue;
        if (!subs[cc2]) { subs[cc2] = new Algo(opts); }
        var out = subs[cc2].calculate({
          markers: groups[cc2],
          map: input.map,
          mapCanvasProjection: input.mapCanvasProjection
        });
        if (out && out.clusters) { clusters = clusters.concat(out.clusters); }
        if (!out || out.changed !== false) { changed = true; }
      }
      // Each sub-algorithm caches per zoom, so coming back to a zoom it already
      // served reports changed=false and MarkerClusterer.render() keeps the old
      // badges. Zoom 3->4 would stay merged. Force a rebuild whenever the mode
      // or the zoom moved.
      if (merged !== lastMerged || zoom !== lastZoom) { changed = true; }
      lastMerged = merged;
      lastZoom = zoom;
      return { clusters: clusters, changed: changed };
    };
    return algo;
  }

  // jquery.storelocator.js:215 builds cluster markers without zIndex whenever
  // clusters_style is custom, so Maps falls back to latitude order and the
  // southern ch badge (21) paints over the fr one (4870). Restore count order.
  function withCountZOrder(renderer) {
    if (!renderer || typeof renderer.render !== 'function' || renderer.__slZOrdered) {
      return renderer;
    }
    return {
      __slZOrdered: true,
      render: function (cluster, stats, map) {
        var marker = renderer.render(cluster, stats, map);
        try {
          var base = google.maps.Marker.MAX_ZINDEX;
          if (marker && marker.setZIndex) {
            marker.setZIndex(Number(base) + (cluster.count || 0));
          }
        } catch (e) { /* leave the marker as the app built it */ }
        return marker;
      }
    };
  }

  function tryPatch() {
    var lib = window.markerClusterer;
    if (!lib || typeof lib.MarkerClusterer !== 'function' || !lib.SuperClusterAlgorithm) {
      return false;
    }
    if (lib.__countryPatched) { return true; }
    var Orig = lib.MarkerClusterer;
    var Algo = lib.SuperClusterAlgorithm;
    function Patched(opts) {
      opts = opts || {};
      if (!opts.algorithm) { opts.algorithm = makeCountryAlgorithm(Algo); }
      opts.renderer = withCountZOrder(opts.renderer);
      return new Orig(opts);
    }
    Patched.prototype = Orig.prototype;
    lib.MarkerClusterer = Patched;
    lib.__countryPatched = true;
    return true;
  }

  // A poll alone loses the race: the 12 s list render blocks the timer while the
  // lib lands and the clusterer is built. Patch on assignment instead.
  if (!tryPatch()) {
    try {
      var lib;
      Object.defineProperty(window, 'markerClusterer', {
        configurable: true,
        get: function () { return lib; },
        set: function (v) { lib = v; tryPatch(); }
      });
    } catch (e) {
      var timer = setInterval(function () { if (tryPatch()) { clearInterval(timer); } }, 10);
      setTimeout(function () { clearInterval(timer); }, 30000);
    }
  }
})();

/* ---- 2. cap the first-load store list ----------------------------------- */
(function () {
  // jquery.storelocator.js:5641 loops `m < fullMapStartListLimit` with no bound
  // check, so a limit above the marker count would hand listSetup undefined.
  function listLimit() {
    var list = window.__slRawLocations();
    var count = list ? list.length : 0;
    return count > 0 ? Math.min(SL_LIST_LIMIT, count) : SL_LIST_LIMIT;
  }

  // The getter must report undefined until the real plugin is assigned, or the
  // plugin's own "already registered" guard makes it bail out entirely.
  function install() {
    var jq = window.jQuerySCASL;
    if (!jq || !jq.fn) { return false; }
    if (jq.fn.__slListLimitPatched) { return true; }
    var real = null;
    try {
      Object.defineProperty(jq.fn, 'storeLocator', {
        configurable: true,
        get: function () {
          if (!real) { return undefined; }
          return function (opts) {
            opts = opts || {};
            if (opts.fullMapStartListLimit === undefined) {
              opts.fullMapStartListLimit = listLimit();
            }
            return real.call(this, opts);
          };
        },
        set: function (v) { real = v; }
      });
    } catch (e) {
      return true;
    }
    jq.fn.__slListLimitPatched = true;
    return true;
  }

  if (!install()) {
    var timer = setInterval(function () { if (install()) { clearInterval(timer); } }, 5);
    setTimeout(function () { clearInterval(timer); }, 30000);
  }
})();
